import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
    Router
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiService } from 'app/services/api/api.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Http, Response, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { SearchZone } from '@core/models/searchzone.model';
import { Store } from '@core/models/store.model';

@Injectable()
export class LocalService implements Resolve<any> {
    user: any;
    local: any;
    ubigeo: any;
    departments: any = [];
    provinces: any = [];
    districts: any = [];
    plantsType: any;
    bank: any;
    routeParams: any;
    localOnChanged: BehaviorSubject<any>;
    stepsOnChanged: BehaviorSubject<any>;
    ubigeoOnChanged: BehaviorSubject<any>;
    departmentsOnChanged: BehaviorSubject<any>;
    provincesOnChanged: BehaviorSubject<any>;
    districtsOnChanged: BehaviorSubject<any>;
    plantsOnChanged: BehaviorSubject<any>;
    bankOnChanged: BehaviorSubject<any>;
    userOnChanged: BehaviorSubject<any>;
    STEPS: {
        STEP1: '1',
        STEP7: '7',
        STEP9: '9'
    };
    searchZones: SearchZone[];
    stores: Store[];

    constructor(
        private _httpClient: HttpClient,
        private _http: Http,
        private _storage: LocalStorageService,
        private _apiService: ApiService,
        private _router: Router
    ) {
        this.localOnChanged = new BehaviorSubject({});
        this.stepsOnChanged = new BehaviorSubject({});
        this.ubigeoOnChanged = new BehaviorSubject({});
        this.departmentsOnChanged = new BehaviorSubject({});
        this.provincesOnChanged = new BehaviorSubject({});
        this.districtsOnChanged = new BehaviorSubject({});
        this.plantsOnChanged = new BehaviorSubject([]);
        this.bankOnChanged = new BehaviorSubject({});
        this.userOnChanged = new BehaviorSubject({});
    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([
                this.get(),
                this.getUbigeo(route),
                this.getDepartments(),
                this.getPlantsType(route),
                this.me(),
                this.getBank(route),
                this.getSearhZones(), 
                this.getStores()
            ]).then(([local]) => {
                this.local = local;
                this.redirect(this.local);
                resolve();
            }, reject);
        });
    }

    redirect(local) {
        if (local) {
            if (local.status !== 'PENDING') {
                this._router.navigate(['/admin/propiedades/list']);
            }
        }
    }

    add(data): Observable<any> {
        const _params = JSON.stringify(data);
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const token = this._storage.retrieve('token');
        if (token) {
            headers.append('Authorization', `Bearer ${token}`);
        }
        return this._http
            .post(this._apiService.local.lead(), _params, { headers })
            .map((response: Response) => response.json())
            .catch((error: Response) => Observable.throw(error.json()));
    }

    update(data) {
        return new Promise((resolve, reject) => {
            this._httpClient
                .put(this._apiService.local.update(this.routeParams.id), {
                    ...data
                })
                .subscribe(
                    (response: any) => {
                        const json = response.data.steps;
                        let steps = [];
                        if (json) {
                            steps = JSON.parse(response.data.steps);
                        }
                        this.stepsOnChanged.next(steps);
                        resolve(response);
                    },
                    (error: HttpErrorResponse) => {
                        reject(error);
                    }
                );
        });
    }
    finish(data) {
        return new Promise((resolve, reject) => {
            this._httpClient
                .put(this._apiService.local.finish(this.routeParams.id), {
                    ...data
                })
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (error: HttpErrorResponse) => {
                        reject(error);
                    }
                );
        });
    }

    addAttach(data: FormData) {
        return new Promise((resolve, reject) => {
            this._httpClient
                .post(
                    this._apiService.local.addAttach(this.routeParams.id),
                    data
                )
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (error: HttpErrorResponse) => {
                        reject(error);
                    }
                );
        });
    }

    addOwnerLead(data) {
        return new Promise((resolve, reject) => {
            this._httpClient
                .post(this._apiService.local.owner_lead(this.routeParams.id), {
                    ...data
                })
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (error: HttpErrorResponse) => {
                        reject(error);
                    }
                );
        });
    }

    deleteAttach(id) {
        return new Promise((resolve, reject) => {
            this._httpClient
                .delete(
                    this._apiService.local.delete_attach(
                        this.routeParams.id,
                        id
                    ),
                    {}
                )
                .subscribe(
                    (response: any) => {
                        resolve(response);
                    },
                    (error: HttpErrorResponse) => {
                        reject(error);
                    }
                );
        });
    }

    get() {
        if (this.routeParams.id) {
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.local.read(this.routeParams.id))
                    .map((res: any) => res.data)
                    .subscribe((local: any) => {
                        this.local = local;
                        this.localOnChanged.next(this.local);
                        const _steps = JSON.parse(this.local.steps);
                        this.stepsOnChanged.next(_steps);
                        resolve(local);
                    }, reject);
            });
        }
    }

    getUbigeo(route: ActivatedRouteSnapshot) {
        if (route.parent.url[0].path === '1') {
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.local.ubigeo())
                    .map((res: any) => res.data)
                    .subscribe((ubigeo: any) => {
                        this.ubigeo = ubigeo;
                        this.ubigeoOnChanged.next(this.ubigeo);
                        resolve(this.ubigeo);
                    }, reject);
            });
        }
    }

    getDepartments(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient
                .get(this._apiService.local.ubigeo_departments())
                .map((res: any) => res.data)
                .subscribe((ubigeo: any) => {
                    this.departments = ubigeo;
                    this.departmentsOnChanged.next(this.departments);
                    resolve(ubigeo);
                }, reject);
        });
    }

    getProvinces(departmentId): Promise<any> {
        this.provinces = [];
        if(departmentId){
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.local.ubigeo_provinces(departmentId))
                    .map((res: any) => res.data)
                    .subscribe((ubigeo: any) => {
                        this.provinces = ubigeo;
                        this.provincesOnChanged.next(this.provinces);
                        resolve(ubigeo);
                    }, reject);
            });
        }
    }

    getDistricts(departmentId, provinceId): Promise<any> {
        this.districts = [];
        if(provinceId){
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.local.ubigeo_districts(departmentId, provinceId))
                    .map((res: any) => res.data)
                    .subscribe((ubigeo: any) => {
                        this.districts = ubigeo;
                        this.districtsOnChanged.next(this.districts);
                        resolve(ubigeo);
                    }, reject);
            });
        }
    }

    getPlantsType(route: ActivatedRouteSnapshot) {
        if (route.parent.url[0].path === '7') {
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.local.plantsType())
                    .map((res: any) => res.data)
                    .subscribe((plants: any) => {
                        this.plantsType = plants;
                        this.plantsOnChanged.next(this.plantsType);
                        resolve(this.plantsType);
                    }, reject);
            });
        }
    }

    me() {
        if (this._storage.retrieve('token')) {
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.user.me())
                    .map((res: any) => res.data)
                    .subscribe((user: any) => {
                        this.user = user;
                        this.userOnChanged.next(this.user);
                        resolve(user);
                    }, reject);
            });
        }
    }

    getBank(route: ActivatedRouteSnapshot) {
        if (route.parent.url[0].path === '9') {
            return new Promise((resolve, reject) => {
                this._httpClient
                    .get(this._apiService.local.bank())
                    .map((res: any) => res.data)
                    .subscribe((bank: any) => {
                        this.bank = bank;
                        this.bankOnChanged.next(this.bank);
                        resolve(bank);
                    }, reject);
            });
        }

    }

    getSearhZones(): Promise<any> {
        const params = new HttpParams()
        .set('pagination', '0')
        .set('active', '1');
        return new Promise((resolve, reject) => {
            this._httpClient
                .get(this._apiService.searchZone.list(), {
                    params
                })
                .map((res: any) => res)
                .subscribe((response: any) => {
                    this.searchZones = response.data;
                    this.searchZones = this.searchZones.map(searchZone => {
                        let newSearchZone = Object.assign(searchZone, {latitud: parseFloat(searchZone.latitud), longitud: parseFloat(searchZone.longitud)})
                        return newSearchZone;
                    });
                    resolve(this.searchZones);
                }, reject);
        });
    }

    getStores(): Promise<any> {
        const params = new HttpParams()
        .set('pagination', 'false');
        return new Promise((resolve, reject) => {
            this._httpClient
                .get(this._apiService.store.list(), {
                    params
                })
                .map((res: any) => res)
                .subscribe((response: any) => {
                    this.stores = response;
                    this.stores = this.stores.map(store => {
                        let newStore = Object.assign(store, {latitud: parseFloat(store.latitud), longitud: parseFloat(store.longitud)})
                        return newStore;
                    });
                    resolve(this.stores);
                }, reject);
        });
    }
}
